import { CSSProperties, useState } from 'react';

import ReactMarkdown from 'react-markdown';

import { ImageArea, InteractiveImageContentData } from '../../../types/contentTypes';
import Card from '../Card';

import './InteractiveImageContent.scss';

interface InteractiveImageContentProps {
  content: InteractiveImageContentData;
  onComplete: () => void;
}

export default function InteractiveImageContent({ content }: InteractiveImageContentProps) {
  const [selectedArea, setSelectedArea] = useState<ImageArea | null>(null);

  const AreaButtons = content.areas.map(area => {
    const style: CSSProperties = {
      position: 'absolute',
      left: `${area.placement[0] * 100}%`,
      top: `${area.placement[1] * 100}%`,
      width: '9%',
      aspectRatio: '1 / 1',
      backgroundColor: 'cornflowerblue',
      borderRadius: '9999px',
    };
    return (
      <button
        style={style}
        key={area.key}
        onClick={() => (area !== selectedArea ? setSelectedArea(area) : setSelectedArea(null))}
      />
    );
  });

  const popupPositionStyle: CSSProperties | undefined = selectedArea
    ? {
        left: `${selectedArea.placement[0] * 100 + 11}%`,
        top: `${selectedArea.placement[1] * 100}%`,
      }
    : undefined;

  return (
    <section className={`interactive-image-content`}>
      <h2 className="strong-heading mb-8">{content.headline}</h2>
      <div className="inline-block relative self-center mb-8">
        <img src={content.imageUrl} alt="upload" />
        {AreaButtons}
        {selectedArea && (
          <Card style={popupPositionStyle} className="popup p-4">
            <ReactMarkdown>{selectedArea.text}</ReactMarkdown>
          </Card>
        )}
      </div>
    </section>
  );
}
